import {create} from 'zustand';

export interface TagStore {
  selectedTagCodes: number[] | null;
  setSelectedTagCodes: (tagCodes: number[]) => void;
  clearSelectedTagCodes: () => void;
}

export const useTagsStore = create<TagStore>()(set => ({
  selectedTagCodes: null,
  setSelectedTagCodes(tagCodes) {
    set({selectedTagCodes: tagCodes});
  },
  clearSelectedTagCodes() {
    set({selectedTagCodes: null});
  },
}));
